import React from 'react'
import { InputBox, InputIconBox } from '../../common/style'
import type { ControlledInputProps, InputProps } from '../types'
import { CustomInput } from '../../../../ui/inputs/CustomInput'

export const TextInput = <T,>({ icon, onIconClick, ...rest }: InputProps & ControlledInputProps<T>) => {
	return (
		<InputBox>
			<CustomInput {...rest} />
			{icon && <InputIconBox onClick={onIconClick}>{icon}</InputIconBox>}
		</InputBox>
	)
}
